import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Tooltip from '@material-ui/core/Tooltip';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import DatePicker from 'react-datepicker';
import sidebarStyle from '../../theme/styles/components/SidebarNavs';
import PrivateWrapper from '../../layout/Private';
import { affiliateCounters } from '../../services/Filmmakers';
import TableLoader from '../../components/TableLoader';
import pageStyle from '../../theme/styles/pages/FormPage';
import 'react-datepicker/dist/react-datepicker.css';

const useStyles = makeStyles(sidebarStyle);
const useStyles2 = makeStyles(pageStyle);
const OverviewPage = () => {
  const pageName = 'Dashboard';
  const classes = useStyles();
  const classes2 = useStyles2();
  const reloadCounterRef = useRef(0);
  const columns = [
    { name: 'Program', id: 'program', align: 'left', width: '15%' },
    { name: 'Views', id: 'title', align: 'center', width: '10%' },
    { name: 'View Minutes', id: 'viewMinutes', align: 'center', width: '10%' },
  ];
  const [dataLoaded, setDataLoaded] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [viewershipStats, setViewershipStats] = useState({
    rows: [],
    totalRows: 0,
    totalViews: 0,
    totalWatchedMinutes: 0,
    page: 1,
  });
  const [dateFilter, setDateFilter] = useState({
    from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to: new Date(),
  });
  const [counters, setCounters] = useState({
    submittedFilmsCount: 0,
    publishedFilmsCount: 0,
    shortlinksClick: 0,
    registrationCount: 0,
    trackingPeriod: 0,
  });

  const apiCall = async (page = 1, append = false) => {
    if (append) {
      setLoadingMore(true);
    } else {
      setDataLoaded(false);
    }

    const user = window.localStorage.getItem('user');
    const userNameObj = user ? JSON.parse(user) : null;
    const endOfDay = new Date(dateFilter.to);
    endOfDay.setHours(23, 59, 59, 999);
    const endOfDayUnix = Math.floor(endOfDay.getTime() / 1000);

    affiliateCounters(
      userNameObj.id,
      Math.floor(new Date(dateFilter.from).getTime() / 1000),
      endOfDayUnix,
      page
    )
      .then((res) => {
        setCounters({
          submittedFilmsCount: res.data.submittedFilmsCount || 0,
          publishedFilmsCount: res.data.publishedFilmsCount || 0,
          shortlinksClick: res.data.shortlinksClick,
          registrationCount: res.data.registrationCount,
          trackingPeriod: res.data.trackingPeriod,
          totalPayouts: res.data.totalPayouts,
        });

        setViewershipStats((prevStats) => ({
          ...prevStats,
          totalRows: res.data.totalRows,
          totalViews: res.data.totalViews,
          totalWatchedMinutes: res.data.totalWatchedMinutes,
          rows: append
            ? [...prevStats.rows, ...res.data.viewershipStats]
            : res.data.viewershipStats,
        }));

        setDataLoaded(true);
        if (append) setLoadingMore(false);
      })
      .catch(() => {
        setDataLoaded(true);
        if (append) setLoadingMore(false);
      });
  };

  const handleViewMore = () => {
    const nextPage = viewershipStats.page + 1;
    apiCall(nextPage, true);
  };

  useEffect(() => {
    apiCall();
  }, [reloadCounterRef.current]);

  return (
    <PrivateWrapper pageName={pageName}>
      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid item xs={12} md={2} sm={2} />
        <Grid item xs={12} md={8} sm={8}>
          <Box
            bgcolor="#ce0e2d"
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="30px"
          >
            <Typography variant="h6" className={classes.menuText}>
              Your Films
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={2} sm={2} />
      </Grid>

      <Grid container spacing={6} style={{ marginTop: 5 }}>
        <Grid item xs={12} md={2} sm={2} />
        <Grid item xs={12} md={4} sm={4}>
          <Card style={{ backgroundColor: '#F2F4F6', height: '180px' }}>
            <CardContent
              style={{
                textAlign: 'center',
                minHeight: '180px',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Submitted Films
              </Typography>
              <Typography variant="h3" component="div">
                {counters.submittedFilmsCount}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4} sm={4}>
          <Card style={{ backgroundColor: '#F2F4F6', height: '180px' }}>
            <CardContent
              style={{
                textAlign: 'center',
                minHeight: '180px',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Published Films
              </Typography>
              <Typography variant="h3" component="div">
                {counters.publishedFilmsCount}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={2} sm={2} />
      </Grid>

      <Grid container spacing={2} style={{ marginTop: 50 }}>
        <Grid item xs={12} md={2} sm={2} />
        <Grid item xs={12} md={8} sm={8}>
          <Box
            bgcolor="#ce0e2d"
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="30px"
          >
            <Typography variant="h6" className={classes.menuText}>
              Promotion Stats
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={2} sm={2} />
      </Grid>

      <Grid container spacing={6} style={{ marginTop: 5 }}>
        <Grid item xs={12} md={2} sm={2} />
        <Grid item xs={12} md={4} sm={4}>
          <Card style={{ backgroundColor: '#F2F4F6', height: '180px' }}>
            <Tooltip
              title={<h2>Total clicks on your films&#39; promo links</h2>}
              arrow
              placement="bottom"
              fontSize={24}
            >
              <CardContent
                style={{
                  textAlign: 'center',
                  minHeight: '180px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                  Total Clicks
                </Typography>
                <Typography variant="h3" component="div">
                  {counters.shortlinksClick}
                </Typography>
              </CardContent>
            </Tooltip>
          </Card>
        </Grid>

        <Grid item xs={12} md={4} sm={4}>
          <Card style={{ backgroundColor: '#F2F4F6', height: '180px' }}>
            <Tooltip
              title={
                <h2>{`Number of users who registered within ${counters.trackingPeriod} days after clicking on your link`}</h2>
              }
              arrow
              placement="bottom"
            >
              <CardContent
                style={{
                  textAlign: 'center',
                  minHeight: '180px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                  Total Signups
                </Typography>
                <Typography variant="h3" component="div">
                  {counters.registrationCount}
                </Typography>
              </CardContent>
            </Tooltip>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 50 }}>
        <Grid item xs={12} md={2} sm={2} />
        <Grid item xs={12} md={8} sm={8}>
          <Box
            bgcolor="#ce0e2d"
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="30px"
          >
            <Typography variant="h6" className={classes.menuText}>
              Viewership Stats
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={2} sm={2} />
      </Grid>
      <Grid container spacing={6} style={{ marginTop: 1 }}>
        <Grid item xs={12} md={2} sm={2} />
        <Grid item xs={12} md={8} sm={8}>
          <Box display="flex" justifyContent="flex-end" gap={2} mb={2}>
            <Box marginRight={2}>
              <DatePicker
                selected={dateFilter.from}
                onChange={(e) => {
                  setDateFilter((prev) => ({
                    ...prev,
                    from: e,
                  }));
                  reloadCounterRef.current += 1;
                }}
                className={classes2.datePickerInput3}
                placeholderText="From"
              />
            </Box>
            <Box>
              <DatePicker
                selected={dateFilter.to}
                onChange={(e) => {
                  setDateFilter((prev) => ({
                    ...prev,
                    to: e,
                  }));
                  reloadCounterRef.current += 1;
                }}
                className={classes2.datePickerInput3}
                placeholderText="To"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={6}>
        <Grid item xs={12} md={2} sm={2} />
        <Grid item xs={12} md={8} sm={8}>
          <Tooltip title={<h2>Viewership from your own account is excluded in the stats</h2>} arrow>
            <TableContainer>
              <Table className={classes.tableData} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell
                        width={col.width}
                        align={col.align || 'left'}
                        key={`col-${col.id}`}
                      >
                        <span>{col.name}</span>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!dataLoaded && <TableLoader cols={9} />}
                  {dataLoaded && viewershipStats.rows.length === 0 && (
                    <TableCell
                      align="center"
                      size="medium"
                      colSpan={3}
                      className={classes.noRecordFoundText}
                    >
                      No records found
                    </TableCell>
                  )}

                  {dataLoaded &&
                    viewershipStats.rows.map((row) => (
                      <TableRow key={`gn-${row.id}`}>
                        <TableCell>
                          <Link href={row.programLink} target="_blank">
                            {row.title || '-'}
                          </Link>
                        </TableCell>
                        <TableCell align="center">{row.views || 0}</TableCell>
                        <TableCell align="center">{row.totalWatchedMinutes || 0}</TableCell>
                      </TableRow>
                    ))}
                  {loadingMore && <TableLoader cols={3} />}
                  {dataLoaded && viewershipStats.rows.length > 0 && (
                    <>
                      {viewershipStats.rows.length < viewershipStats.totalRows && !loadingMore && (
                        <TableRow>
                          <TableCell align="center" colSpan={4}>
                            <span
                              role="button"
                              tabIndex={0}
                              onClick={handleViewMore}
                              style={{ cursor: 'pointer', borderBottom: '1px solid black' }}
                              onKeyPress={(e) => {
                                if (e.key === 'Enter') handleViewMore();
                              }}
                            >
                              <b>View all</b>
                            </span>
                          </TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell>
                          <b>Total</b>
                        </TableCell>
                        <TableCell align="center">
                          <b>{viewershipStats.totalViews || 0}</b>
                        </TableCell>
                        <TableCell align="center">
                          <b>{viewershipStats.totalWatchedMinutes || 0}</b>
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={2} sm={2} />
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 10, marginBottom: 10 }}>
        <Grid item xs={12} md={2} sm={2} />
        <Typography variant="body2" color="inherit" style={{ textAlign: 'center', width: '100%' }}>
          To view your revenue and payment details, go to the Payment tab in the left side menu
        </Typography>
        <Grid item xs={12} md={2} sm={2} />
      </Grid>
    </PrivateWrapper>
  );
};

export default OverviewPage;
